// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, RedirectToHomePage } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { KEEP_ME_SIGNED_IN_STORAGE_KEYS } from "@stoneage/XDL/constants";
import { parseBoolean } from "@stoneage/XDL/Utilities";

type HandlerType = Handler;

export const XngRedirectToHomePage: HandlerType = props => {
    const state = props.getState();
    window.location.href = (getSettingsCollection(state).customSettings as any).cognitoSignOutUrl;
};

export const UpdateKeepMeSignedInModalStateOnSignOut: HandlerType = props => {
    const isUserRetained = parseBoolean(props.getState().context.session.properties.isUserRetained);
    if (isUserRetained) {
        localStorage.removeItem(KEEP_ME_SIGNED_IN_STORAGE_KEYS.lastShown);
    }
};
replaceInChain(chain, RedirectToHomePage, XngRedirectToHomePage);
addToEndOfChain(chain, UpdateKeepMeSignedInModalStateOnSignOut);
